/* eslint-disable import/prefer-default-export */
export function typeMember(type) {
  const memberMap = ['', 'Parent', 'Child']

  return memberMap[type] || ''
}
